import React from 'react';
import { useAppSelector } from 'flow/hooks/useRedux';
import { prettyFormatE164Number } from 'flow/utils/call-utils';
import { TypedMap } from 'flow/types/TypedMap';
import { ContactFull } from 'flow/types/Contact';
import { TelephoneNumber } from 'flow/types/TelephoneNumber';
import { selectUserCountryCode } from 'flow/selectors/ExtensionSelectors';
import NumberWrapper from 'flow/components/ui-components/NumberWrapper';

interface Props {
    contact?: TypedMap<ContactFull>;
    contactFullName?: string;
    number?: TypedMap<TelephoneNumber>;
}

const ContactSubtitleExtended = ({
    contact,
    contactFullName,
    number,
}: Props) => {
    const userCountryCode = useAppSelector(selectUserCountryCode);

    const contactIsAnExtension = contact?.get('type') === 'bound';
    const companyName = contact?.get('companyName');
    const department = contact?.get('department');
    const formattedNumber = prettyFormatE164Number(
        number?.get('number'),
        userCountryCode,
    );

    const parts: Array<React.ReactNode> = [];

    if (contactFullName) {
        parts.push(contactFullName);
    }

    if (contactIsAnExtension && department) {
        parts.push(department);
    } else if (companyName && companyName !== contactFullName) {
        parts.push(companyName);
    }

    if (formattedNumber) {
        parts.push(<NumberWrapper>{formattedNumber}</NumberWrapper>);
    }

    if (parts.length === 0) return null;

    return (
        <>
            {parts.reduce<React.ReactNode[]>((acc, part, index) => {
                if (index > 0) acc.push(' \u2022 ');
                acc.push(part);
                return acc;
            }, [])}
        </>
    );
};

export default React.memo(ContactSubtitleExtended);
